import React, { Component } from "react";
import { Link } from "react-router-dom";
import { theme } from "../../assets/theme/theme";

import ActionModal from "../../components/Common/ActionModal";

class ClaimDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: null, // approve | reject | return
    };
  }

  renderStatus(status) {
    const map = {
      Draft: ["#F1F5F9", "#475569"],
      "Pending Approval": ["#FFF7E6", "#B76E00"],
      "Pending Finance": ["#FFF7E6", "#C2410C"],
      Approved: ["#ECFDF3", "#027A48"],
      Paid: ["#EAF8FB", "#027A7A"],
      Rejected: ["#FEECEC", "#B42318"],
    };

    const [bg, color] = map[status] || map.Draft;

    return (
      <span style={{ background: bg, color, padding: "6px 12px", borderRadius: 20, fontSize: 12, fontWeight: 900 }}>
        {status}
      </span>
    );
  }

  renderInfoRow(label, value) {
    return (
      <div style={{ marginBottom: 14 }}>
        <div style={infoLabel}>{label}</div>
        <div style={infoValue}>{value || "-"}</div>
      </div>
    );
  }

  renderSection(title, children) {
    return (
      <div style={card}>
        <h5 style={sectionTitle}>{title}</h5>
        {children}
      </div>
    );
  }

  renderTimeline() {
    const items = [
      ["Submitted", "Lee Min Hao submitted the claim.", "20 May 2024, 09:15 AM", true],
      ["Manager Review", "Pending manager approval.", "-", false],
      ["Finance Review", "Waiting for finance verification.", "-", false],
      ["Payment", "Payment will be processed after final approval.", "-", false],
    ];

    return (
      <div>
        {items.map((item, index) => (
          <div key={index} style={{ display: "flex", gap: 12, marginBottom: 18 }}>
            <div style={{
              width: 24,
              height: 24,
              borderRadius: "50%",
              background: item[3] ? "#DC111C" : "#E5E7EB",
              color: item[3] ? "#fff" : "#94A3B8",
              textAlign: "center",
              lineHeight: "24px",
              fontSize: 12,
              fontWeight: 900,
              flexShrink: 0,
            }}>
              {index + 1}
            </div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 900, color: "#0F172A" }}>{item[0]}</div>
              <div style={{ fontSize: 12, color: "#64748B", marginTop: 3 }}>{item[1]}</div>
              <div style={{ fontSize: 11, color: "#94A3B8", marginTop: 3 }}>{item[2]}</div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  render() {
    const claim = {
      id: "CLM-2024-0187",
      type: "Local Travel Claim",
      status: "Pending Approval",
      employee: "Lee Min Hao",
      employee_id: "EMP-2024-0041",
      department: "Operations",
      position: "Operations Executive",
      submitted_at: "20 May 2024, 09:15 AM",
      related_ref: "TR-2024-0081",
      amount: "1,250.00",
      purpose: "Client site visit",
      period: "15 May 2024 - 17 May 2024",
      route: "Kuching → Kuala Lumpur",
    };

    const rows = [
      ["1", "15 May 2024", "Flight", "Kuching to Kuala Lumpur flight ticket", "FLT-150524", "520.00"],
      ["2", "15 May 2024", "Transport", "Airport transfer and Grab rides", "GRB-150524", "85.00"],
      ["3", "16 May 2024", "Accommodation", "Hotel stay for 2 nights", "HTL-160524", "520.00"],
      ["4", "17 May 2024", "Meal", "Meal allowance during travel", "-", "125.00"],
    ];

    return (
      <div style={{ padding: 24 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
          <div>
            <Link to="/claim" style={{ color: theme.colors.brand.primary || "#DC111C", fontSize: 13, fontWeight: 800, textDecoration: "none" }}>
              ← Back to Claim Module
            </Link>

            <h4 style={{ margin: "12px 0 6px", fontWeight: 900, color: "#0F172A" }}>
              {claim.id}
            </h4>

            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <span style={{ color: "#64748B", fontSize: 13 }}>{claim.type}</span>
              {this.renderStatus(claim.status)}
            </div>
          </div>

          <div style={{ display: "flex", gap: 10 }}>
            <button style={secondaryButton}>Download PDF</button>

            <button
              onClick={() => this.setState({ modal: "return" })}
              style={secondaryButton}
            >
              Return
            </button>

            <button
              onClick={() => this.setState({ modal: "reject" })}
              style={dangerButton}
            >
              Reject
            </button>

            <button
              onClick={() => this.setState({ modal: "approve" })}
              style={primaryButton}
            >
              Approve
            </button>
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: 18 }}>
          <div>
            {this.renderSection(
              "Claim Information",
              <div style={grid2}>
                {this.renderInfoRow("Claim ID", claim.id)}
                {this.renderInfoRow("Claim Type", claim.type)}
                {this.renderInfoRow("Related Trip / Reference", claim.related_ref)}
                {this.renderInfoRow("Submitted Date", claim.submitted_at)}
                {this.renderInfoRow("Claim Period", claim.period)}
                {this.renderInfoRow("Travel Route", claim.route)}
                <div style={{ gridColumn: "1 / span 2" }}>
                  {this.renderInfoRow("Purpose", claim.purpose)}
                </div>
              </div>
            )}

            {this.renderSection(
              "Expense Items",
              <div>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ background: "#F8FAFC", color: "#475569", fontSize: 12 }}>
                      {["#", "Date", "Category", "Description", "Receipt Ref", "Amount (RM)"].map((h) => (
                        <th key={h} style={thStyle}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row) => (
                      <tr key={row[0]} style={{ borderTop: "1px solid #E5E7EB" }}>
                        {row.map((col, index) => (
                          <td key={index} style={{ ...tdStyle, textAlign: index === 5 ? "right" : "left" }}>
                            {col}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div style={{
                  marginTop: 14,
                  padding: 14,
                  borderRadius: 8,
                  background: "#F8FAFC",
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: 900,
                }}>
                  <span>Total Claim Amount</span>
                  <span>RM {claim.amount}</span>
                </div>
              </div>
            )}

            {this.renderSection(
              "Supporting Documents",
              <div>
                {[
                  "Flight_Ticket_KCH_KUL.pdf",
                  "Grab_Receipts_150524.pdf",
                  "Hotel_Invoice_160524.pdf",
                  "Trip_Approval_TR-2024-0081.pdf",
                ].map((file) => (
                  <div key={file} style={fileRow}>
                    <span style={{ fontSize: 13, fontWeight: 800 }}>{file}</span>
                    <button style={secondarySmallButton}>View</button>
                  </div>
                ))}
              </div>
            )}

            {this.renderSection(
              "Approver Comment",
              <textarea
                placeholder="Enter approval, rejection or return comment..."
                style={{
                  width: "100%",
                  minHeight: 110,
                  border: "1px solid #CBD5E1",
                  borderRadius: 8,
                  padding: 12,
                  fontSize: 13,
                  outline: "none",
                }}
              />
            )}
          </div>

          <div>
            {this.renderSection(
              "Claim Summary",
              <div>
                {this.renderInfoRow("Employee", claim.employee)}
                {this.renderInfoRow("Employee ID", claim.employee_id)}
                {this.renderInfoRow("Department", claim.department)}
                {this.renderInfoRow("Position", claim.position)}
                {this.renderInfoRow("Total Amount", `RM ${claim.amount}`)}
              </div>
            )}

            {this.renderSection("Approval Timeline", this.renderTimeline())}

            {this.renderSection(
              "Finance Status",
              <div>
                {this.renderInfoRow("Finance Review", "Not started")}
                {this.renderInfoRow("Payment Status", "Pending")}
                {this.renderInfoRow("Payment Date", "-")}
              </div>
            )}
          </div>
        </div>
        <ActionModal
          show={!!this.state.modal}
          type={this.state.modal}
          title={`Confirm ${this.state.modal}`}
          onClose={() => this.setState({ modal: null })}
          onConfirm={() => {
            alert(`Action: ${this.state.modal}`);
            this.setState({ modal: null });
          }}
        />
      </div>
    );
  }
}

const card = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  padding: 20,
  marginBottom: 18,
};

const sectionTitle = {
  margin: "0 0 18px",
  fontWeight: 900,
  color: "#0F172A",
};

const grid2 = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "4px 22px",
};

const infoLabel = {
  fontSize: 12,
  color: "#64748B",
  fontWeight: 800,
};

const infoValue = {
  fontSize: 14,
  color: "#0F172A",
  fontWeight: 800,
  marginTop: 4,
};

const thStyle = {
  padding: "12px 14px",
  textAlign: "left",
  fontWeight: 900,
  whiteSpace: "nowrap",
};

const tdStyle = {
  padding: "14px",
  fontSize: 13,
  color: "#334155",
  verticalAlign: "middle",
};

const fileRow = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  border: "1px solid #E5E7EB",
  borderRadius: 8,
  padding: "12px 14px",
  marginBottom: 10,
};

const primaryButton = {
  background: "#DC111C",
  color: "#fff",
  border: 0,
  borderRadius: 8,
  padding: "10px 16px",
  fontWeight: 900,
  cursor: "pointer",
};

const dangerButton = {
  background: "#B42318",
  color: "#fff",
  border: 0,
  borderRadius: 8,
  padding: "10px 16px",
  fontWeight: 900,
  cursor: "pointer",
};

const secondaryButton = {
  background: "#fff",
  color: "#334155",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "9px 14px",
  fontWeight: 800,
  cursor: "pointer",
};

const secondarySmallButton = {
  ...secondaryButton,
  padding: "6px 10px",
  fontSize: 12,
};

export default ClaimDetail;